module.exports = (dispatcher, events) => {

	function stockConnexionUri(url){
		dispatcher.emit(events.STOCK_CONNEXION_URI, url);
	}

	function checkRedirectValue(){
		dispatcher.emit(events.CHECK_REDIRECT_VALUE);
	}

	function hasBeenRedirect(){
		dispatcher.emit(events.HAS_BEEN_REDIRECT);
	}

	function getProjects() {
		dispatcher.emit(events.GET_PROJECTS);
	}

	function getCurrentProject(id) {
		dispatcher.emit(events.GET_CURRENT_PROJECT, id);
	}

	function getAllProjects() {
		dispatcher.emit(events.GET_ALL_PROJECTS);
	}

	function getPersonnalProjects() {
		dispatcher.emit(events.GET_PERSONNAL_PROJECTS);
	}

	function getBackedProjects() {
		dispatcher.emit(events.GET_BACKED_PROJECTS);
	}

	function getProfile() {
		dispatcher.emit(events.GET_PROFILE);
	}

	function getUsersList() {
		dispatcher.emit(events.GET_USERS_LIST);
	}

	function checkForNotifications() {
		dispatcher.emit(events.GET_NOTIFICATIONS);
	}

	function postInviteSeen(project_id) {
		dispatcher.emit(events.POST_INVITE_SEEN,project_id);
	}

	/*
	 * Envoi d'une réponse à un projet sur lequel on est invité
	 * value : 1 ou 2, 1 = accept, 2 = decline
	 */
	function answerInvite(project_id,value) {
		dispatcher.emit(events.ANSWER_INVITE,project_id,value);
	}
	

	/*
	 * Affichage d'une modal
	 * value : string, qui correspond au type de modal affichée
	 */
	function displayModal(value) {
		dispatcher.emit(events.DISPLAY_MODAL, value);
	}

	function hideModal() {
		dispatcher.emit(events.HIDE_MODAL);
	}

	/*
	 * Création d'un projet
	 * payload : object payload avec infos du projet
	 */
	function postProject(payload) {
		dispatcher.emit(events.POST_PROJECT, payload);
	}

	/*
	 * Edition d'un projet
	 * payload : object payload avec infos du projet
	 */
	function editProject(payload) {
		dispatcher.emit(events.EDIT_PROJECT, payload);
	}

	/*
	 * Update de la route en cours
	 * value : "string" libellé de la route en cours
	 */
	function setCurrentRoute(value) {
		dispatcher.emit(events.SET_CURRENT_ROUTE, value);
	}

	/*
	 * Backing d'un projet
	 * value : string id du projet et number valeur de l'ajout
	 */
	function backingAction(project_id,amount,title) {
		dispatcher.emit(events.POST_TRANSACTION,project_id,amount,title);
	}

	/*
	 * Ajout de users autorisés à consulter un projet
	 * users_id : identifiants des users ajoutés, project_id : id du projet
	 */
	function inviteBackers(users_id,project_id) {
		dispatcher.emit(events.ADD_ALLOWED_BACKERS,users_id,project_id);
	}

	function getWallet() {
		dispatcher.emit(events.GET_WALLET);
	}

	function deleteProject(data) {
		dispatcher.emit(events.DELETE_PROJECT, data);
	}

	function inviteBackersByEmail(project,users) {
		dispatcher.emit(events.INVITE_BACKERS_BY_EMAIL, project,users);
	}

	/*
	 * Retire les users déjà invités sur un projet pour avoir une liste de gens à inviter acurate
	 * payload : object, tous les users - usersList : object, tous les users déjà invités
	 */
	function filterUsersList(payload,usersList){
		dispatcher.emit(events.FILTER_BACKERS_INVITE, payload);
	}

	/*
	 * Renseigne une date dans le champ "achieved_at" du projet
	 * data : data concernant le projet
	 */
	function achieveProject(data){
		dispatcher.emit(events.ACHIEVE_PROJECT, data);
	}

	/*
	 * Envoi d'un mail à l'office manager pour prevenir de l'achevement d'un projet
	 * project : object contenant les infos du projet achevé
	 */
	function achieveProjectEmail(project){
		dispatcher.emit(events.ACHIEVE_PROJECT_EMAIL, project);
	}

	/*
	 * Update les transactions du projet à currentDate et update la fin du projet à un mois après currentDate
	 * data : data concernant le projet
	 */
	function moveProjectToCurrentYear(data){
		dispatcher.emit(events.MOVE_PROJECT_TO_CURRENT_YEAR, data);
	}

	/*
	 * Envoi d'un mail à l'office manager avec la facture d'un projet achevé
	 * data : object contenant les infos du projet achevé + la ou les factures uploadée(s)
	 */
	function sendBillToOM(data){
		dispatcher.emit(events.SEND_BILL_TO_OM, data);
	}

	function getAllTransactions(){
		dispatcher.emit(events.GET_ALL_TRANSACTIONS);
	}

	function getAllWallets(){
		dispatcher.emit(events.GET_ALL_WALLETS);
	}

	return {
		stockConnexionUri,
		checkRedirectValue,
		hasBeenRedirect,
		getProjects,
		getCurrentProject,
		getAllProjects,
		getBackedProjects,
		getPersonnalProjects,
		getProfile,
		getUsersList,
		setCurrentRoute,
		displayModal,
		hideModal,
		postProject,
		editProject,
		backingAction,
		getWallet,
		inviteBackers,
		checkForNotifications,
		postInviteSeen,
		answerInvite,
		deleteProject,
		inviteBackersByEmail,
		filterUsersList,
		achieveProject,
		achieveProjectEmail,
		moveProjectToCurrentYear,
		getAllTransactions,
		getAllWallets,
		sendBillToOM
	};
};


// WEBPACK FOOTER //
// ./src/Actions/index.js